<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Default" />
            <o-button label="Primary" variant="primary" />
            <o-button label="Secondary" variant="secondary" />
            <o-button label="Success" variant="success" />
            <o-button label="Info" variant="info" />
            <o-button label="Warning" variant="warning" />
            <o-button label="Danger" variant="danger" />
        </p>
    </section>
</template>
